<template>
  <section class="container">
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    <div class="bind-modal">
      <van-cell-group title="工单类型">
        <van-radio-group style="margin-left:15px" label-position="center" v-model="workOrderType"
          direction="horizontal">
          <van-radio style="font-size:14px" icon-size="18px" :name="1">售后</van-radio>
          <van-radio style="font-size:14px" icon-size="18px" :name="2">投诉</van-radio>
          <van-radio style="font-size:14px" icon-size="18px" :name="3">反馈</van-radio>
        </van-radio-group>
      </van-cell-group>
      <van-cell-group style="margin-top:10px" title="基础信息">
        <!-- <van-field v-model="parkName." label="*泊位编号" placeholder="请输入泊位编号" input-align='right' readonly/> -->
        <van-field v-show="workOrderType!=3" v-model="pendingBill.parkName" readonly label="岗位名称" placeholder="请选择岗位名称"
          input-align='right' />
        <van-field v-show="workOrderType!=3" v-model="pendingBill.cardNumber" readonly label="车牌号码"
          placeholder="请输入车牌号码" input-align='right' />
        <van-field v-show="workOrderType!=3" v-model="pendingBill.newPlatformId" readonly label="订单编号"
          placeholder="请输入订单编号" input-align='right' />
        <van-field required v-show="workOrderType==1" @click="show=true" v-model="problemitem" label="问题类型"
          placeholder="请选择问题类型" input-align='right' readonly is-link />
        <van-field required v-model="problemDescription" label="问题描述" placeholder="请输入问题描述" input-align='right' autosize
          rows="5" maxlength="300" type="textarea" />
      </van-cell-group>
      <van-cell-group style="margin-top:10px" title="问题图片">
        <van-uploader :deletable="false" :after-read="afterRead" v-model="fileList" multiple :max-count="3" />
      </van-cell-group>
      <van-cell-group style="margin-top:10px" title="联系人信息">
        <van-field required v-model="contacts" label="联系人" placeholder="请输入联系人" input-align='right' />
        <van-field required v-model="pendingBill.mobileNumber" label="联系电话" placeholder="请输入联系电话" input-align='right' />
      </van-cell-group>
      <div class="btn_box">
        <van-button @click="submit" size="large" class="blue-btn">提交申请</van-button>
      </div>
    </div>

  </section>
</template>

<script>
import { ActionSheet, Area, Uploader, RadioGroup, Radio, Cell, CellGroup, Field, Toast } from 'vant'
import { currencyPost } from '@/api/park'
import { Base64 } from 'js-base64'
import lrz from "lrz";
import { upload } from '@/api/park'
import { parseTime } from '@/utils'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Pay-Parking-Cost',
  components: {
    [Area.name]: Area,
    [ActionSheet.name]: ActionSheet,
    [Uploader.name]: Uploader,
    [Cell.name]: Cell,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Toast.name]: Toast,
  },
  data () {
    this.phoneRules = [
      { required: true, message: '请输入手机号码' },
      { validator: this.phoneValidator, message: '手机号码格式错误' },
    ];
    return {
      config, //全局项目配置信息
      workOrderType: 1,
      problemType: 1,
      problemitem: '缴费问题',
      plateNumber: [],
      columns: [],
      show1: false,
      show: false,
      actions: [{ name: '缴费问题', type: 1 }, { name: '开票问题', type: 2 }, { name: '其它问题', type: 2 }],
      parkdata: null,
      park: null,
      contacts: '',
      problemDescription: '',
      problemPicture: "",
      fileList: [
      ],
    }
  },
  computed: {
    ...mapGetters(['pendingBill'])
  },
  mounted () {

  },
  methods: {
    phoneValidator (val) {
      return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(val);
    },
    onSelect (item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      this.problemType = item.type
      this.problemitem = item.name
    },
    afterRead (file) {
      let _this = this;
      // 此时可以自行将文件上传至服务器
      lrz(file.file, { quality: 0.1 }).then(function (rst) {
        // 处理成功会执行
        let uploadFormData = new FormData()
        uploadFormData.append('file', rst.file)
        uploadFormData.append('bucket', 'carflow-images')
        uploadFormData.append('fileName', file.file.name)
        uploadFormData.append('appKey', '1cf18da3372245bd96ffac517411313c')
        uploadFormData.append('imghostUrl', 'http://fn.sdzbkj.cn/f/upload')
        upload(uploadFormData, { "Content-Type": "multipart/form-data" }).then(res => {
          _this.problemPicture += Base64.decode(res.data) + ';'
          console.log(_this.problemPicture)
        }).catch(err => {
          console.log(err)
          _this.$toast.fail('上传图片失败')
        })
      })


    },
    submit () {
      let _this = this;
      if (_this.contacts && _this.problemDescription && this.phoneValidator(_this.pendingBill.mobileNumber)) {
        let data = {
          parkId: _this.pendingBill.parkId,//停车场编号
          workOrderType: _this.workOrderType,//工单类型
          portNumber: null,//泊位号
          parkName: _this.pendingBill.parkName,//停车场
          contacts: _this.contacts,//联系人
          contactInformation: _this.pendingBill.mobileNumber,//联系方式
          carNumber: _this.pendingBill.cardNumber,//车牌号码
          associatedOrderNumber: _this.pendingBill.newPlatformId,//关联订单编号
          problemType: _this.problemType,//问题类型
          problemDescription: _this.problemDescription,//问题描述
          workOrderStatus: 1,//工单状态 1待受理
          submissionTime: parseTime(new Date()),//提交时间
          problemPicture: _this.problemPicture.slice(0, _this.problemPicture.length - 1),//图片地址
        }
        let params = {
          url: "http://road.sdzbkj.cn:9000/park/financeCloudApi/workOrderRecord/insert",
          parameter: JSON.stringify(data)
        }
        currencyPost(params).then(res => {
          _this.$notify({
            type: 'sucess',
            message: '提交成功！'
          })
          _this.$router.push({ name: 'Invoice-Temporary' })
        }).catch(err => {
          _this.$notify({
            type: 'danger',
            message: '提交失败，请联系管理员！'
          })
        })

      } else {
        this.$toast.fail('请完善相关信息！')
      }
    },



  },

}
</script>

<style lang="scss" scoped>
.container {
  .bind__header {
    display: flex;
    flex-direction: colunm;
    flex-wrap: wrap;
    padding: 25px;
    margin-top: 10px;
    background: linear-gradient(
      -52deg,
      rgba(26, 73, 251, 1),
      rgba(71, 140, 245, 1)
    );

    &__info {
      width: 50%;
      color: rgba(255, 255, 255, 1);

      span {
        display: block;
      }

      &__title {
        font-size: 17px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        line-height: 26px;
      }

      &__content {
        font-size: 14px;
        line-height: 38px;
      }
    }

    &__2dpic {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 50%;
      height: 20vh;
      min-height: 140px;
    }
  }

  .bind-modal {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 600px;
    max-width: 90%;
    height: 65vh;
    min-height: 400px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(37, 44, 63, 0.1);
    border-radius: 5px;
    margin: 0 auto;
    .title {
      text-align: left;
      font-size: 17px;
      line-height: 1.5;
      line-height: 1.5;
      padding: 25px 0 10px;
    }

    .btn_box {
      padding: 10px 15px 30px 15px;
    }

    .page {
      padding: 10px;
    }
  }
  .header {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: px2rem(140);
    min-height: px2rem(140);
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &__info {
      width: 70%;
      height: 50%;
      display: flex;
      flex-direction: colunm;
      flex-wrap: wrap;
      align-items: center;

      span {
        color: #fff;
        text-align: center;
      }

      &__title {
        width: 100%;
        font-size: 22px;
        font-weight: 500;
      }

      &__content {
        width: 100%;
        font-size: 18px;
      }
    }
  }

  .prompt_tips {
    font-size: 18px;
    text-align: center;
  }

  .page {
    padding: px2rem(15);
    margin: px2rem(10) 0 px2rem(20);
  }

  .btn_box {
    padding: 0 15px;
  }
}
</style>